import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivityService } from '@shared/services/activity.service';
import { Observable } from 'rxjs';

@Injectable()
export class ActivityInterceptor implements HttpInterceptor {
  constructor(private activityService: ActivityService) {
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    this.activityService.httpRequestCalled$.next();
    return next.handle(req);
  }
}
